const storagePrefix = "Bearer";

const storage = {
  getToken: function () {
    return JSON.parse(window.localStorage.getItem(`${storagePrefix}_token`));
  },
  setToken: function (token) {
    window.localStorage.setItem(`${storagePrefix}_token`, JSON.stringify(token));
  },
  clearToken: function () {
    window.localStorage.removeItem(`${storagePrefix}_token`);
  },
};

export default storage;
